import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import { Tabs, Item as TabItem } from 'devextreme-react/tabs';
import TabPanel, { Item as TabPanelItem } from 'devextreme-react/tab-panel';
import Box, { Item as BoxItem } from 'devextreme-react/box';
import AntCondition from '../utils/AntCondition';
import AntLocalization from '../utils/AntLocalization';

export default function (props) {

    // const [selectedTabIndex, setSelectedTabIndex] = useState(
    //     props.selectedTabIndex !== undefined ? props.selectedTabIndex : props.defaultSelectedIndex !== undefined ? props.defaultSelectedIndex : 0
    // );

    const initTabs = useCallback(() => {
        let tabs = props.rawTabs.filter((tab, i) => {
            if (props.formData) {
                let visible = AntCondition.isVisible(props.formData, tab);
                if (!visible) return false;
            }
            return true;
        });
        return tabs;
    }, [props.rawTabs, props.formData]);

    const mainTabs = useMemo(() => initTabs(), [props.rawTabs, props.formData, props.shouldRender]);

    // const handleTabChanged = (e) => {
    //     if (e.fullName === 'selectedIndex') {
    //         let tabIndex = e.value >= 0 ? e.value : 0;
    //         setSelectedTabIndex(tabIndex);
    //     }
    // };

    // const handleAccordionChanged = useCallback(
    //     (e) => {
    //         if (e.addedItems.length > 0) {
    //             let selectedTabName = e.addedItems[e.addedItems.length - 1].name;

    //             let tabIndex = props.rawTabs.findIndex((t) => t.name === selectedTabName);
    //             if (tabIndex >= 0) setSelectedTabIndex(tabIndex);
    //         }
    //     },
    //     [props.rawTabs]
    // );

    // const tabStyle = useMemo(() => {
    //     var style = props.tabStyle !== undefined ? props.tabStyle : 'COLLAPSE';
    //     if (!style) style = 'COLLAPSE';
    //     style = String(style).toUpperCase();
    //     return style;
    // }, [props.tabStyle]);

    // useEffect(() => {
    //     var tab = mainTabs[selectedTabIndex];
    //     var tabName = tab && tab.name ? tab.name : String(selectedTabIndex);
    //     if (props.onTabChanged) props.onTabChanged(tabName, selectedTabIndex);
    // }, [selectedTabIndex]);

    const isVisible = props.visible !== undefined ? props.visible : true;
    const isMultipleTabs = isVisible && props.tabs instanceof Array && props.tabs.length > 1;
    // if (!isVisible) return <React.Fragment> </React.Fragment>;


    const itemTitleRender = useCallback((data) => {
        return (
            <div
                id={data.name}
                key={data.name}
                className={
                    Boolean(data?.isClicked) ? 'ant-pos-screen-main-section ant-pos-screen-main-section-focused' : 'ant-pos-screen-main-section'
                }
            >
                {data.caption
                    ? AntLocalization.translateText(data.caption)
                    : data.label
                    ? AntLocalization.translateText(data.label)
                    : data.name
                    ? data.name
                    : ''}
            </div>
        );
    }, []);

    if (!isMultipleTabs && props.onRenderTabContent) {
        let tab = props.tabs[0];
        let tabName = tab && tab.name ? tab.name : String(0);
        let mTab = (isVisible ? mainTabs : []).find((t) => t.name === tabName);
        return props.onRenderTabContent(mTab);
    } else
        return (
            <React.Fragment>
                <TabPanel
                    className={'ant-pos-screen-main-sections'}
                    stylingMode={'primary'}
                    itemTitleRender={itemTitleRender}
                    itemRender={props.onRenderTabContent}
                    animationEnabled={true}
                    swipeEnabled={true}
                    focusStateEnabled={false}
                    iconPosition={'top'}
                    height={'100%'}
                    // selectedItem={selectedMode}
                    // selectedIndex={selectedTabIndex !== undefined ? selectedTabIndex : 0}
                    items={isVisible ? mainTabs : []}
                    // onSelectionChanged={handleAccordionChanged}
                    deferRendering={false}
                />
            </React.Fragment>
        );
}
